import React from 'react';
import PropTypes from 'prop-types';

const ProductCard = ({model, productId, onClickActionBtn}) => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="card-preview-container" onClick={() => onClickActionBtn(productId, model)}>
          <p style={{fontSize: 32}}>{model.word}</p>
        </div>

        <div className="card-title-container">
          <h4 className="card-title">{model.title}</h4>
          <h5 className="card-subtitle">{model.subtitle}</h5>
        </div>
      </div>
    </div>
  );
};

ProductCard.propTypes = {
  model: PropTypes.object.isRequired,
  productId: PropTypes.string.isRequired,
  onClickActionBtn: PropTypes.func.isRequired,
};

export default ProductCard;
